module.exports = __webpack_public_path__ + "img/Origins_100_on_Vimeo@2x.5794043f.png";